import { jwtDecode } from 'jwt-decode'
import moment from 'moment';
import ReactDOMServer from "react-dom/server"
import { Box, Text } from '@chakra-ui/react';
import store from '../store/store';
import axiosInstance from '../Services/axiosInstance';
export const extractErrorMessageFromResponse = (respone) => {

    let message = "";
    if (respone?.response?.data?.status == 'failure') {
        message = "Something went wrong. Please check your credentials."
    } else {
        message = "Something went wrong with the server. Contact the administrator "
    }
    return message;
}

export const extractUserDataFromJWT = async (data) => {

    let token = data?.data?.data?.jwt || data;
    let decodedToken = jwtDecode(token);
    
    
    let retVal = {
    
        exp: moment(decodedToken.exp * 1000),
        jwt: token
    }
    
    return retVal;
}

export const setTokenInLocalStorage = (token) => {
    
    localStorage.setItem("token", JSON.stringify(token));
    localStorage.setItem("userData",JSON.stringify(token?.user_data))
}

export const getTokenFromLoacalStorage = () => {

    let token = localStorage.getItem("token");
    // let decodedToken = extractUserDataFromJWT(JSON.parse(token) )
    let selectedOrg = localStorage.getItem("selectedOrg");

    if (!!token && !!selectedOrg) {
        token = JSON.parse(token);
        selectedOrg = JSON.parse(selectedOrg);
    }

    // console.log('getTokenFromLoacalStorage',{ user_data: token?.user_data, exp: moment(token?.exp), jwt: token?.jwt, token: selectedOrg?.token })
    return { user_data: token?.user_data, exp: moment(token?.exp), jwt: token?.jwt, token: selectedOrg?.token, selectedOrg: JSON.stringify(selectedOrg), isSuperAdmin: token?.isSuperAdmin };
}
export const getOrgName = (token) => {

    const orgList = store.getState().org.orgList
    let orgName = orgList.filter((e) => e.token == token)
    return orgName[0]?.name || ''
}
export function isTokenExpired(tokenExpiryTime) {
    // Get current time in UTC (GMT)
    const currentTime = moment().utc();
    
    // Parse tokenExpiryTime as UTC (assuming it's in a valid format, e.g., ISO 8601)
    const tokenTime = moment.utc(tokenExpiryTime);
    
    // Check if tokenTime is valid
    if (!tokenTime.isValid()) {
        throw new Error('Invalid token expiry time format');
    }
    
    // Return true if the token has expired (current time is after token expiry time)
    // Use minutes difference to check if token is expired (less than or equal to 1 minute remaining)
    return currentTime.isAfter(tokenTime) || tokenTime.diff(currentTime, 'minutes') <= 1;
}
export function tokenTimeDifference(tokenExpiryTime) {
    const currentTime = moment();
    const tokenTime = moment(tokenExpiryTime)
    //const tokenExpiry = authData.tokenExpiry;
    return currentTime.diff(tokenExpiryTime, "m")
}

export const isProduction = () => {
    return !window.location.host.includes("localhost");
}
export const CHANNELS = {
    email: 'Email', push: 'Push', sms: 'SMS', whatsapp: 'WhatsApp', mobile: 'Mobile Push', inApp: "In App"
}

export const getTargetAudienceTypes = {

    SEND_TO_ALL: 'sendToAll', EXISTING_CSV: 'existingCsv', UPLOAD_CSV: 'uploadCsv', PREDEFINED_SEGMENTS: 'predefined', CUSTOM_SEGMENT: 'custom',
    RFM_SEGMENT: 'rfm', KLAVIYO: 'klaviyo', DAMAS_CRM: 'damasCrm'

};

export const showSwal = (swalInstance, title, desc, showLoaderOnConfirm, showCancelButton, confirmButtonText, cancelButtonText, preConfirmCallback, callback) => {
    swalInstance.fire({
        html: ReactDOMServer.renderToStaticMarkup(
            <Box display={'flex'} flexDirection={'column'} gap={6}>
                <Text mb={6} as={'b'} fontSize={'xl'}>{title}</Text>
                <Text fontSize={'md'}>{desc}</Text>
            </Box>
        ),
        showLoaderOnConfirm: !!showLoaderOnConfirm,
        showCancelButton: !!showCancelButton,
        confirmButtonText: confirmButtonText || 'Okay',
        cancelButtonText: cancelButtonText || 'No',
        preConfirm: preConfirmCallback,

    }).then(res => {
        callback(res)
    })
}

export const apeendRequiredScript = () => {

}